document.addEventListener("DOMContentLoaded", function () {
    var endlessScroll = new Ajaxinate({
        container: '#main-collection-product-grid',
        pagination: '#AjaxinatePagination',
        loadingText: 'Loading...'
    });

    // Re-initialize Ajaxinate when filters update the product grid
    var grid = document.getElementById('CollectionProductGrid');
    if (grid) {
        var observer = new MutationObserver(function (mutations) {
            var loop = document.getElementById('main-collection-product-grid');
            var pagination = document.getElementById('AjaxinatePagination');

            // Check if the container element reference has changed
            // This happens when facets.js replaces the innerHTML of CollectionProductGrid
            if (loop && endlessScroll.containerElement !== loop) {
                if (endlessScroll) {
                    endlessScroll.destroy();
                }

                if (pagination) {
                    endlessScroll = new Ajaxinate({
                        container: '#main-collection-product-grid',
                        pagination: '#AjaxinatePagination',
                        loadingText: 'Loading...'
                    });
                }
            }
        });

        observer.observe(grid, { childList: true });
    }
});
